import { createIntl, createIntlCache } from 'react-intl'
import translations from '../../translations/locales'
import { detectLanguage } from './i18n'

let locale = detectLanguage();
const cache = createIntlCache();
const intl = createIntl({ locale, messages: translations[locale] }, cache);

export const localeOptions = [
    { value: 'fr', label: intl.formatMessage({ id: 'locale.french', defaultMessage: 'Français' }) },
    { value: 'en', label: intl.formatMessage({ id: 'locale.english', defaultMessage: 'Anglais' }) },
];

export const shortBusinessUnitOptions = [
    { value: 'tech', label: intl.formatMessage({ id: 'business_unit.tech', defaultMessage: 'Tech' }) },
    { value: 'sales', label: intl.formatMessage({ id: 'business_unit.sales', defaultMessage: 'Sales' }) },
    { value: 'marketing', label: intl.formatMessage({ id: 'business_unit.marketing', defaultMessage: 'Marketing' }) },
];

export const shortAllBusinessUnitOptions = [
    { value: 'all', label: intl.formatMessage({ id: 'business_unit.all', defaultMessage: 'Toutes' }) },
    { value: 'tech', label: intl.formatMessage({ id: 'business_unit.tech', defaultMessage: 'Tech' }) },
    { value: 'sales', label: intl.formatMessage({ id: 'business_unit.sales', defaultMessage: 'Sales' }) },
    { value: 'marketing', label: intl.formatMessage({ id: 'business_unit.marketing', defaultMessage: 'Marketing' }) },
];

export const businessUnitOptions = [
    { value: 'data', label: intl.formatMessage({ id: 'business_unit.data', defaultMessage: 'Data' }) },
    { value: 'tech', label: intl.formatMessage({ id: 'business_unit.tech', defaultMessage: 'Tech' }) },
    { value: 'sales', label: intl.formatMessage({ id: 'business_unit.sales', defaultMessage: 'Sales' }) },
    { value: 'marketing', label: intl.formatMessage({ id: 'business_unit.marketing', defaultMessage: 'Marketing' }) },
    { value: 'design', label: intl.formatMessage({ id: 'business_unit.design', defaultMessage: 'Design' }) },
    { value: 'product', label: intl.formatMessage({ id: 'business_unit.product', defaultMessage: 'Product' }) },
    { value: 'other', label: intl.formatMessage({ id: 'business_unit.other', defaultMessage: 'Autres' }) },
];

export const allBusinessUnitOptions = [
    { value: 'all', label: intl.formatMessage({ id: 'business_unit.all', defaultMessage: 'Toutes' }) },
    { value: 'data', label: intl.formatMessage({ id: 'business_unit.data', defaultMessage: 'Data' }) },
    { value: 'tech', label: intl.formatMessage({ id: 'business_unit.tech', defaultMessage: 'Tech' }) },
    { value: 'sales', label: intl.formatMessage({ id: 'business_unit.sales', defaultMessage: 'Sales' }) },
    { value: 'marketing', label: intl.formatMessage({ id: 'business_unit.marketing', defaultMessage: 'Marketing' }) },
    { value: 'design', label: intl.formatMessage({ id: 'business_unit.design', defaultMessage: 'Design' }) },
    { value: 'product', label: intl.formatMessage({ id: 'business_unit.product', defaultMessage: 'Product' }) },
    { value: 'other', label: intl.formatMessage({ id: 'business_unit.other', defaultMessage: 'Autres' }) },
];

export const colorOptions = [
    { value: 'primary', label: intl.formatMessage({ id: 'color.blue', defaultMessage: 'Bleu' }) },
    { value: 'danger', label: intl.formatMessage({ id: 'color.pink', defaultMessage: 'Rose' }) },
    { value: 'warning', label: intl.formatMessage({ id: 'color.yellow', defaultMessage: 'Jaune' }) },
];

export const sortOptions = [
    {
        value: 'desc',
        label: intl.formatMessage({ id: 'options.sort.desc', defaultMessage: 'Du plus récent au plus ancien' })
    },
    {
        value: 'asc',
        label: intl.formatMessage({ id: 'options.sort.asc', defaultMessage: 'Du plus ancien au plus récent' })
    }
];

export const coverOptions = [
    { value: 'all', label: intl.formatMessage({ id: 'options.cover.all', defaultMessage: 'Toutes' }) },
    { value: 'accepted', label: intl.formatMessage({ id: 'options.cover.accepted', defaultMessage: 'Acceptées' }) },
    { value: 'pending', label: intl.formatMessage({ id: 'options.cover.pending', defaultMessage: 'En attente' }) },
    { value: 'refused', label: intl.formatMessage({ id: 'options.cover.refused', defaultMessage: 'Refusées' }) },
];

export const interviewOptions = [
    { value: 'all', label: intl.formatMessage({ id: 'options.interview.all', defaultMessage: 'Tous' }) },
    {
        value: 'first',
        label: intl.formatMessage({ id: 'options.interview.first', defaultMessage: '1ers entretiens effectués' })
    },
    {
        value: 'in_progress',
        label: intl.formatMessage({ id: 'options.interview.pending', defaultMessage: 'En cours' })
    },
    {
        value: 'none',
        label: intl.formatMessage({ id: 'options.interview.none', defaultMessage: 'Aucun entretien effectué' })
    },
];

export const placementOptions = [
    { value: 'all', label: intl.formatMessage({ id: 'options.placement.all', defaultMessage: 'Tous' }) },
    { value: 'done', label: intl.formatMessage({ id: 'options.placement.done', defaultMessage: 'Effectué' }) },
    {
        value: 'in_progress',
        label: intl.formatMessage({ id: 'options.placement.pending', defaultMessage: 'En cours' })
    },
    {
        value: 'cancelled',
        label: intl.formatMessage({ id: 'options.placement.cancelled', defaultMessage: 'Mission annulée' })
    },
];

export const remoteOptions = [
    { value: 0, label: intl.formatMessage({ id: 'forms.remote.options.none' }) },
    { value: 1, label: intl.formatMessage({ id: 'forms.remote.options.partial' }) },
    { value: 2, label: intl.formatMessage({ id: 'forms.remote.options.full' }) },
];

export const coverTypeOptions = [
    { value: 'pending_covers', label: 'Covers en attente' },
    { value: 'accepted_covers', label: 'Covers acceptées' },
    { value: 'first_interview_covers', label: 'Covers avec 1 interview' },
    { value: 'dealt_covers', label: 'Covers dealées' },
    { value: 'more_interviews_covers', label: 'Covers avec plus d\'1 interview' },
    { value: 'refused_covers', label: 'Covers refusées' },
];
